<template>
  <component
    v-for="({ logo, headline, caption, link }, index) in registeredCouriers"
    :is="link ? HyperLink : 'article'"
    :key="index"
    class="flex items-center gap-300"
    v-bind="{ ...$attrs, ...(link && { to: link }) }"
  >
    <NuxtImg
      v-if="logo"
      :alt="link ? '' : logo.title"
      class="logo"
      :height="logo.height"
      :src="logo.url"
      :width="logo.width"
    />

    <span>
      <span class="headline-h5-headline">
        {{ headline }}
      </span>

      <p class="mt-100 caption-regular text-secondary-secondary">
        {{ caption }}
      </p>
    </span>
  </component>
</template>

<script lang="ts" setup>
import HyperLink from '~/components/HyperLink/HyperLink.vue'

const { data: footer } = useContent().getFooter()

const registeredCouriers = computed(() =>
  (footer.value?.items ?? []).flatMap((item) =>
    (item?.sealsCollection?.items ?? []).flatMap((seal) => {
      if (!seal) return []
      const { caption, headline, link, logo } = seal

      // TODO Remove fallbacks when contentful schema finally gets it's shit together
      return {
        caption: caption ?? '',
        headline: headline ?? '',
        link: link ?? null,
        logo: logo
          ? {
              height: logo.height ?? 0,
              title: logo.title ?? '',
              url: logo.url ?? '',
              width: logo.width ?? 0,
            }
          : null,
      }
    }),
  ),
)
</script>

<style lang="scss" scoped>
.logo {
  flex-shrink: 0;
  width: 6.25rem;
}

a {
  position: relative;
  color: inherit;
  text-decoration: none;
  cursor: pointer;

  @include focus-state {
    box-shadow: 0 0 0 token('size/border/200') token('color/border/accent/focused/focused');
  }
}
</style>
